export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const REFRESH = 'REFRESH';
export const SET_ITEM_SELECTED = 'SET_ITEM_SELECTED';
export const LOAD_INIT_DATA = 'LOAD_INIT_DATA';
export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';